var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","sm":"3"}},[_c('domain-filter-field',{model:{value:(_vm.filters.domain),callback:function ($$v) {_vm.$set(_vm.filters, "domain", $$v)},expression:"filters.domain"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }